import * as React from 'react';
export const IcLoans = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.53 6.55h6.95l.68-1.3c.07-.13.1-.27.1-.42 0-.15-.04-.29-.12-.42a.92.92 0 00-.31-.31.777.777 0 00-.42-.11h-1.7c-.21 0-.42.08-.58.23l-.7.62-.7-.65a.823.823 0 00-.58-.2H8.6c-.14 0-.29.04-.42.11s-.23.18-.31.31c-.08.13-.12.27-.12.42 0 .15.03.29.1.42l.68 1.3zM17.98 11.27h.01a8.38 8.38 0 00-2.43-3.02H8.45c-1.03.8-1.86 1.84-2.43 3.02a8.502 8.502 0 00-.82 3.78c0 .06.08 5.95 6.8 5.95s6.8-5.89 6.8-5.95c.03-1.31-.26-2.6-.82-3.78z'
      fill='currentColor'
    />
  </svg>
);
